import { Checkbox } from "antd";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalDAStatus, setGlobalIsGetDetail} from "../../../store/reducer/globalMultipleSearchSelect.reducer";

const MSSDAStatus = ({
  setValueMSS,
  valueMSS,
  children,
  togglerClassName,
  placeholder,
  className,
  filterByGrologAccountId,
  ...attrs
}) => {
  const dispatch = useDispatch();

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const btnDropdownRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [totalData, setTotalData] = useState(2);
  const [listSelected, setListSelected] = useState([]);
  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const {
    globalDepotName,
    globalDAStatus,
    globalDA,
    globalOrderStatus,
    globalTrip,
    globalTripStatus,globalIsGetDetail
  } = useSelector((state) => state.globalMSS);
  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  useEffect(()=>{
    if(globalIsGetDetail){
    setListSelected(
      // globalDepotName.every(item => item >= 0) ? 
      // globalDepotName.map((item)=> {
      // return { id: item }}) : globalDepotName)
      globalDAStatus?.every(item => item !== "ALL")&& typeof globalDAStatus[0] !== 'object' ? 
      listData?.filter(itemB => globalDAStatus?.includes(itemB?.id)): globalDAStatus)
    
      dispatch(setGlobalIsGetDetail(false))
    }
    // dispatch(setGlobalIsGetDetail(true))
  },[globalDAStatus])

  const isCheckedSelectAll = useMemo(() => {
    if (listSelected !== undefined && listSelected.length === totalData) {
      setIsSelectedAll(true);
      return true;
    }
    setIsSelectedAll(false);
    return false;
  }, [listSelected, totalData]);

  const isCheckedPerItem = useCallback(
    (item) => {
      if (listSelected.length > 0) {
        if (listSelected.length === totalData || listSelected.includes("ALL")) {
          return true;
        }
        const isExist = listSelected.some((el) => el.id === item.id);
        return isExist;
      }
      return false;
    },
    [listSelected, totalData]
  );

  const isAllDepot = useMemo(() => {
    if (listSelected.length) {
      if (listSelected.includes("ALL")) {
        return true;
      }
      const length = listSelected.length;
      if (listSelected.length > 0 && length === totalData) {
        return true;
      }
    }
    return false;
  }, [listSelected, totalData]);

  const listData = useMemo(() => {
    const list = [
      { id: "ALL", name: "All DA Status" },
      { id: "Active", name: "Active" },
      { id: "Expired", name: "Expired" },
    ];
    return list;
  }, []);

  const handleClickSelectData = useCallback(
    (item) => {
      if (item?.id === "ALL") {
        if (listSelected.length === 0 || !listSelected) {
          setListSelected(["ALL"]);
          dispatch(setGlobalDAStatus(["ALL"]));
          return;
        }
        if (listSelected.length && listSelected.length - 1 !== totalData) {
          if (listSelected.includes("ALL")) {
            setListSelected([]);
            dispatch(setGlobalDAStatus([]));
            return;
          }
          setListSelected(["ALL"]);
          dispatch(setGlobalDAStatus(["ALL"]));
          return;
        }
        if (listSelected.length && listSelected.includes("ALL")) {
          setListSelected([]);
          dispatch(setGlobalDAStatus([]));
        }

        return;
      }
      if (item?.id !== "ALL") {
        if (listSelected.length === 0) {
          const listDataSelected = listSelected;
          listDataSelected.push(item);
          setListSelected([...listDataSelected]);
          dispatch(setGlobalDAStatus([...listDataSelected]));
          return;
        }
        const isAllSelected = listSelected.includes("ALL");

        if (isAllSelected) {
          const idFiltering = ["ALL"];
          idFiltering.push(item?.id);
          const newList = listData.filter(
            (el) => !idFiltering.includes(el?.id)
          );
          setListSelected([...newList]);
          dispatch(setGlobalDAStatus([...newList]));
          return;
        }
        const isExist = listSelected.some((el) => el?.id === item?.id);
        if (isExist) {
          const listDataFiltered = listSelected.filter(
            (el) => el?.id !== item?.id
          );
          setListSelected([...listDataFiltered]);
          dispatch(setGlobalDAStatus([...listDataFiltered]));
          return;
        } else {
          const list = listSelected;
          list.unshift(item);
          setListSelected([...list]);
          dispatch(setGlobalDAStatus([...list]));
          return;
        }
      }
    },
    [dispatch, listData, listSelected, totalData]
  );

  return (
    <div
      className={"dropdown-dds".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className="value-mss"
        onClick={togglerDropdownContent}
        ref={btnDropdownRef}
      >
        {isAllDepot ? (
          <span className="list-value-mss">All DA Status</span>
        ) : isCheckedSelectAll === false && listSelected.length !== 0 ? (
          listSelected.map((item, index) => (
            <span key={index} className="list-value-mss">
              {item?.name}
            </span>
          ))
        ) : (
          <span className="placeholder-mss">Select DA Status</span>
        )}
      </button>
      <div></div>
      <div
        className={"dropdown-dds-menu".concat(
          isShowDropdownContent ? " active mt-2 pb-10" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="overflow-auto max-h-[300px]">
          {listData?.map((el, index) => (
            <div
              key={index}
              className={"dropdown-dds-item truncate"}
              onClick={() => handleClickSelectData(el)}
            >
              <div className="w-full flex justify-between px-2">
                <span>{el?.name}</span>
                <Checkbox checked={isCheckedPerItem(el)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MSSDAStatus;
